<template>
  <modal id="clinic-not-found">
    <div class="text-center">
      <div class="page-title">Clinic not available</div>
    </div>

    <p class="my-4">Sorry, your chosen clinic isn't currently available for pay as you go physio.</p>
    <p class="mb-4">Please browse appointments at our other nearby clinics.</p>
    <p class="mb-4">Call us at <a href="tel:+443306780850">0330 678 0850</a> if you would like to speak to a member our Booking Team.</p>

    <hr />

    <div class="modal-footer text-center">
      <a href="#" @click.prevent="hideModal" class="btn btn-secondary">Browse nearby clinics</a>
    </div>
  </modal>
</template>

<script>
  import Modal from '../../Global/Modal';

  export default {
    name: 'clinic-not-found',

    components: {
      Modal,
    },

    created() {
      this.listen('modal.shown', this.modalShown);
    },

    destroyed() {
      this.silence('modal.shown', this.modalShown);
    },

    methods: {
      modalShown(id) {
        if (id === 'clinic-not-found') {
          this.dispatch('location.blur');
        }
      },
    },
  }
</script>
